import { defineAction } from '~/prix'
import generalResidenceFetchReportAction from './generalResidenceFetchReport.action.json' with { type: 'json' }
import { z } from 'zod'
import { reportFormatSchema } from '~/utils/server/report'

const generalResidenceFetchReportDefinition = defineAction({
  ...generalResidenceFetchReportAction,

  input: z.object({
    type: z.enum(['publicSafety', 'publicHealth']),
    id: z.string().uuid(),
    format: reportFormatSchema,
  }),
  output: z.any(),
})

export default generalResidenceFetchReportDefinition
